// What type of media controls to display in the viewer
export enum MediaEnum {
  None = 'none',
  Small = 'small',
  Full = 'full',
}
